import {TdrRegelAard} from "../tdr-regel/tdr-regel-aard.enum";

export class AsPlaats {
  naam: string;
  afstand: number;
  gridLijn: boolean;
  aankomstVertrek: boolean;
  aard: TdrRegelAard;
}
